import { memo } from 'react';
import { MEDIA_PLAYER_COLORS } from '../../constants/Colors';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const TimelineLine = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "mediaTimeline-pillLine",
    position: "relative",
    insetBlockStart: "12px",
    inlineSize: "100%",
    blockSize: "2px",
    backgroundColor: MEDIA_PLAYER_COLORS.DEFAULT_STATUS_FILL,
    children: children
  });
};
export default /*#__PURE__*/memo(TimelineLine);